(function ( $ ) {

	$.fn.filterformatter = function ( options ) {
		var $elem = $( this ),
			menuActiveStateClass = 'is-active',
			listCondensedStateClass = 'cards--condensed',
			$controllers = $( '.filter-menu__format-option' ),
			controllerClassNormal = 'js-filterformatter--normal',
			controllerClassCondensed = 'js-filterformatter--condensed',
			$btnNormal = $controllers.filter( '.' + controllerClassNormal ),
			$btnCondensed = $controllers.filter( '.' + controllerClassCondensed ),
			$cardList = $elem,
			defaultMode = 'normal',
			currMode;

		var init = function () {

				// Set initial view
				getOption();
				toggleList();


				$controllers.on( 'click', function ( e ) {
					e.preventDefault();

					toggleList( $( this ) );
				} );
			},
			toggleList = function ( $clickedToggle ) {

				if ( typeof $clickedToggle == 'undefined' ) {
					// No actual click. Initial setup, for instance
					$clickedToggle = $controllers.filter( '.js-filterformatter--' + currMode );
				}

				if ( $clickedToggle.is( $btnCondensed ) ) {
					$cardList.addClass( listCondensedStateClass );
					currMode = 'condensed';
				} else if ( $clickedToggle.is( $btnNormal ) ) {
					$cardList.removeClass( listCondensedStateClass );
					currMode = 'normal';
				}

				$controllers.not( $clickedToggle ).removeClass( menuActiveStateClass );
				$clickedToggle.addClass( menuActiveStateClass );

				saveOption();
			},
			getOption = function () {
				// Just setting up these options
				if ( typeof CAF == 'undefined' ) {
					CAF = {};
				}

				if ( typeof CAF.OPTIONS == 'undefined' ) {
					CAF.OPTIONS = {};
				}


				var savedPrefs = Cookies.getJSON( 'caf-event-filter-mode' );

				if ( savedPrefs ) {
					currMode = savedPrefs;
				} else {
					currMode = defaultMode;
				}

				CAF.OPTIONS.eventFilterMode = currMode;
			},
			saveOption = function () {
				Cookies.set( 'caf-event-filter-mode', currMode, { expires : 365 } );
			};

		init();
		return this;
	};

}( $ ));
